import type { Logger } from '@dma/shared';
import type { AuthRepository } from '../../domain/repositories/AuthRepository.interface';

export class SignOutUseCase {
  constructor(
    private readonly repository: AuthRepository,
    private readonly logger: Logger
  ) {}

  public async execute(): Promise<void> {
    await this.repository.signOut();
    this.logger.info('Admin sign-out succeeded');
  }
}
